// extracted by mini-css-extract-plugin
export default {"ace-c-quality-report-modal__attachments":"create-quality-report-modal__attachments---5c12b4c7"};